/*
PW LongPress

Render a button-like object that requires the user to press/click
for {props.pressTime} before completing the bound action
*/

import React from 'react'
import T from 'prop-types'
import cx from 'classnames'
import Timing from '../hoc/Timing'

class LongPress extends React.Component {
  static displayName = 'LongPress'

  static propTypes = {
    children: T.node,
    onPressed: T.func.isRequired,
    className: T.string,
    pressTime: T.number,

    setTimer: T.func.isRequired,
    clearTimer: T.func.isRequired
  }

  static defaultProps = {
    pressTime: 500
  }

  constructor(props) {
    super(props)
    this.state = {
      pressing: false
    }
  }

  _startPress = e => {
    e.stopPropagation()
    this.setState({ pressing: true })
    this.props.setTimer(this._onPressed, this.props.pressTime, 'press')
  }

  _stopPress = e => {
    e.stopPropagation()
    this.props.clearTimer('press')
    this.setState({ pressing: false })
  }

  _onPressed = () => {
    this.setState({ pressing: false })
    if (this.props.onPressed) {
      this.props.onPressed()
    }
  }

  _onKeyDown = e => {
    if (e.key === 'Enter' && !this.state.pressing) {
      this._startPress(e)
    }
  }

  render() {
    const { props, state } = this
    const _time = props.pressTime + 'ms'
    const _inlineStyles = {
      // transitionDuration: _time
      // webkitTransitionDuration: _time
      animationDuration: _time,
      WebkitAnimationDuration: _time
    }

    return (
      <span
        className={cx(
          'long_press',
          props.className,
          state.pressing ? 'pressing' : null
        )}
        data-testid={props['data-testid']}
        onMouseDown={this._startPress}
        onMouseUp={this._stopPress}
        onMouseOut={this._stopPress}
        onTouchStart={this._startPress}
        onTouchEnd={this._stopPress}
        onKeyDown={this._onKeyDown}
        onKeyUp={this._stopPress}
        role="button"
        tabIndex={0}
      >
        <div className="filler" style={_inlineStyles} />
        <span className="press_content">
          {props.children}
        </span>
      </span>
    )
  }
}

export default Timing(LongPress)
